const STORAGE_NATIVE_STORE_RATING_LOCK = 'NativeFunctions__NativeStoreRatingLock';

export const getNativeStoreRatingLock = () => {
  const lock = localStorage.getItem(STORAGE_NATIVE_STORE_RATING_LOCK);
  if (lock) {
    const result = JSON.parse(lock);
    return !!result;
  }
  return false;
};

export const setNativeStoreRatingLock = (value: boolean) => {
  localStorage.setItem(STORAGE_NATIVE_STORE_RATING_LOCK, JSON.stringify(value));
};
